import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const exportCogsReport = {
  name: "exportCogsReport" as const,
  input: z.object({
    mode: z.enum(["cogs", "openLayers"]),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
